<div  class="usuaris-content">
  <div class="mdl-grid mdl-grid--no-spacing">
    <h5 class="mdl-layout-title mdl-cell--8-col">
      {{::'DEFAULT_ROL' | translate}}
    </h5>
    <div class="mdl-cell mdl-cell--4-col">
      <div class="itec-float-right">
	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"
					 	ng-if="::$root.permisos.ESBORRARROL.delete"
	          itec-dialog-confirm
	          itec-dialog-confirm-title="{{::'DEFAULT_TITOL_CONFIRMACIO_ESBORRAR' | translate}}"
	          itec-dialog-confirm-text-content="{{::'ROL_DELETE_CONTENT' | translate}}"
	          itec-dialog-confirm-text-ok="DIALOG_CONFIRM"
	          itec-dialog-confirm-text-cancel="DIALOG_CANCEL"
	          itec-dialog-confirm-function-ok="ctrl.deleteElem()">
	        <i class="material-icons">delete</i>
	      </button>
	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"
								ng-if="::$root.permisos.ACTUALITZARROL.edit"
								ng-click="ctrl.changeToForm()">
	        <i class="material-icons">edit</i>
	      </button>
      </div>
    </div>
  </div>



   <div class="mdl-cell--12-col">
      <md-card>
        <md-card-content>
          <div class="mdl-grid mdl-grid--no-spacing">
	            <div class="mdl-cell mdl-cell--3-col">
	              <span>{{::'DEFAULT_NOM' | translate}}:</span>
	            </div>
	            <div class="mdl-cell mdl-cell--9-col">
	              <span class="bold">{{::ctrl.rol.nom}}</span>
	            </div>

	            <div class="mdl-cell mdl-cell--3-col">
	              <span>{{::'DEFAULT_ENTITAT' | translate}}:</span>
	            </div>
	            <div class="mdl-cell mdl-cell--9-col">
	              <span class="bold">{{::ctrl.rol.entitat[0].nom}}</span>
	            </div>
	            <div class="mdl-cell mdl-cell--3-col">
	              <span>{{::'DEFAULT_PRODUCTE' | translate}}:</span>
	            </div>
	            <div class="mdl-cell mdl-cell--9-col">
	              <span class="bold">{{::ctrl.rol.producte[0].nom}}</span>
	            </div>

				<div class="mdl-cell mdl-cell--3-col" ng-show="::ctrl.issuperadmin">
	              <span>{{::'DEFAULT_ADMINISTRADOR' | translate}}:</span>
	            </div>
	            <div ng-if="::ctrl.rol.administrador===true"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">
	              <span class="bold">{{::'DEFAULT_SI' | translate}}</span>
	            </div>
	            <div ng-if="::ctrl.rol.administrador===false"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">
	              <span class="bold">{{::'DEFAULT_NO' | translate}}</span>
	            </div>

				<div class="mdl-cell mdl-cell--3-col" ng-show="::ctrl.issuperadmin">
	              <span>{{::'ROL_ES_POT_ELIMINAR' | translate}}:</span>
	            </div>
	            <div ng-if="::ctrl.rol.eliminar===true"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">
	              <span class="bold">{{::'DEFAULT_SI' | translate}}</span>
	            </div>
	            <div ng-if="::ctrl.rol.eliminar===false"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">
	              <span class="bold">{{::'DEFAULT_NO' | translate}}</span>
	            </div>


				<div class="mdl-cell mdl-cell--3-col" ng-show="::ctrl.issuperadmin">
	              <span>{{::'ROL_INICIAL' | translate}}:</span>
	            </div>
	            <div ng-if="::ctrl.rol.inicial===true"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">
	              <span class="bold">{{::'DEFAULT_SI' | translate}}</span>
	            </div>
	            <div ng-if="::ctrl.rol.inicial===false"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">
	              <span class="bold">{{::'DEFAULT_NO' | translate}}</span>
	            </div>


	            <div class="mdl-cell mdl-cell--3-col" ng-show="::ctrl.issuperadmin">
	              <span>{{::'ROL_VISIBLEALL' | translate}}:</span>
	            </div>
	            <div ng-if="::ctrl.rol.visibleall===true"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">
	              <span class="bold">{{::'DEFAULT_SI' | translate}}</span>
	            </div>
	            <div ng-if="::ctrl.rol.visibleall===false"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">
	              <span class="bold">{{::'DEFAULT_NO' | translate}}</span>
	            </div>

            </div>
          <div class="horizontal_separator"></div>
        </md-card-content>
      </md-card>
    </div>
</div>
